export const datatypeDropdownOptions = [
  'varchar',
  'string',
  'blob',
  'date',
  'timestamp',
  'integer',
  'decimal',
];

export const orderByOptions = ['ASC', 'DESC'];

export const initialIngestionMetaData = {
  uploadType: 'sample',
  uploadedFileName: '',
  uploadedFileLocation: '',
  metadata_source: false,
  metadata_file_name: '',
  metadata_file_location: '',
  feedType: '',
  contentType: '',
  volume_of_data: '',
  precedence: '',
  data_source_object: '',
  connector: null,
  data_source_type: '',
  datashare_name: null,
  priority_processing: false,
  incremental_field: [],
};

export const dataTypeOutMapping = {
  REDSHIFT: {
    smallint: 'smallint',
    integer: 'int',
    bigint: 'bigint',
    decimal: 'numeric(38,18)',
    real: 'float',
    boolean: 'string',
    char: 'string',
    varchar: 'string',
    'character varying': 'string',
    string: 'string',
    date: 'date',
    time: 'string',
    'time without time zone': 'string',
    'time with time zone': 'string',
    timez: 'string',
    timestamp: 'timestamp',
    timestampz: 'string',
    'timestamp without time zone': 'timestamp',
    'timestamp with time zone': 'timestamp',
    'double precision': 'double',
  },
  EXCEL: {
    varchar2: 'string',
    string: 'string',
    varchar: 'string',
    date: 'date',
    timestamp: 'timestamp',
    blob: 'string',
    integer: 'bigint',
    decimal: 'numeric(38,18)',
    boolean: 'string',
    byte: 'string',
    currency: 'string',
    long: 'bigint',
    double: 'double',
  },
  DELIMITED: {
    varchar2: 'string',
    string: 'string',
    varchar: 'string',
    date: 'date',
    timestamp: 'timestamp',
    blob: 'string',
    integer: 'bigint',
    decimal: 'numeric(38,18)',
    boolean: 'string',
  },
};

export const dataTypeInMapping = {
  REDSHIFT: [
    'smallint',
    'integer',
    'bigint',
    'decimal',
    'real',
    'boolean',
    'char',
    'varchar',
    'string',
    'date',
    'timestamp',
    'varbyte',
  ],
  XML: ['integer', 'string', 'decimal', 'boolean', 'date', 'time'],
  EXCEL: [
    'boolean',
    'byte',
    'currency',
    'date',
    'timestamp',
    'decimal',
    'double',
    'integer',
    'long',
    'string',
    'varchar',
  ],
  JSON: ['string', 'number', 'boolean', 'null', 'object', 'array'],
  PARQUET: [
    'boolean',
    'float',
    'double',
    'byte_array',
    'string',
    'uuid',
    'decimal',
    'date',
    'interval',
    'int(64, true)',
    'int(8, true)',
    'int(16, true)',
    'int(32, true)',
  ],
  ICEBERG: [
    'binary',
    'boolean',
    'date',
    'decimal',
    'double',
    'float',
    'int',
    'list',
    'long',
    'map',
    'string',
    'time',
    'uuid',
  ],
  ORACLE: [
    'char',
    'nchar',
    'varchar2',
    'nvarchar2',
    'clob',
    'long',
    'number',
    'date',
    'blob',
    'raw',
    'bfile',
    'long raw',
    'string',
  ],
  FIXED: [
    'varchar2',
    'string',
    'varchar',
    'date',
    'timestamp',
    'blob',
    'integer',
    'decimal',
  ],
  DELIMITED: [
    'varchar2',
    'string',
    'varchar',
    'date',
    'timestamp',
    'blob',
    'integer',
    'decimal',
  ],
};

export const dateTimeFormatOptions = [
  'yyyy-MM-dd',
  'yyyy-MM-ddThh:mm:ss',
  'yyyy-MM-ddThh:mm:ssZ',
  'yyyy-MM-ddThh:mm:ss±hh:mm',
  'YYYY-Www-D',
  'YYYY-Www-DThh:mm:ss',
  'YYYY-DDD',
  "yyyy-MM-dd'T'HH:mm:ss CST",
  "yyyy-MM-dd'T'HH:mm:ss.SSS CST",
  "yyyy-MM-dd'T'HH:mm:ss EST",
  "yyyy-MM-dd'T'HH:mm:ss.SSS EST",
  "yyyy-MM-dd'T'HH:mm:ss PST",
  "yyyy-MM-dd'T'HH:mm:ss.SSS PST",
  "yyyy-MM-dd'T'HH:mm:ss MST",
  "yyyy-MM-dd'T'HH:mm:ss.SSS MST",
];

export const screen2Headers = [
  {
    header: 'Field Name',
    key: 'name',
    label: 'Name of input file column',
    align: 'bottom',
    width: '150px',
  },
  {
    header: 'Data Type',
    key: 'data_type',
    label: 'Data type of the field',
    align: 'bottom',
    width: '150px',
  },
  {
    header: 'Data Length',
    key: 'length',
    label: 'Minimum length of the input field',
    align: 'bottom',
    width: '125px',
  },
  {
    header: 'Date Format',
    key: 'common_regex',
    label: 'Format of date if data type is selected as date/timestamp',
    align: 'bottom',
    width: '225px',
  },
  {
    header: 'Non Nullable Field',
    key: 'nullable',
    label: 'Checks if field values cannot contain empty or null values.',
    align: 'bottom',
    width: '125px',
  },
  {
    header: 'Encrypted Fields',
    key: 'cleanspclchar',
    label:
      'If the field values are encrypted. Special characters will not be cleaned',
    align: 'bottom',
    width: '125px',
  },
];

export const viewConfigHeaders = [
  {
    header: 'Field Name',
    key: 'name',
    label: 'Name of input file column',
    align: 'bottom',
  },
  {
    header: 'Data Type',
    key: 'data_type',
    label: 'Data type of the field',
    align: 'bottom',
  },
  {
    header: 'Data Length',
    key: 'length',
    label: 'Minimum length of the input field',
    align: 'bottom',
  },
  {
    header: 'Date Format',
    key: 'common_regex',
    label: 'Format of date if data type is selected as date/timestamp',
    align: 'bottom',
  },
  {
    header: 'Non Nullable Field',
    key: 'nullable',
    label: 'Checks if field values cannot contain empty or null values.',
    align: 'bottom',
  },
  {
    header: 'Encrypted Fields',
    key: 'cleanspclchar',
    label:
      'If the field values are encrypted. Special characters will not be cleaned',
    align: 'bottom',
  },
];

export const s3Screen2Tooltips = {
  name: 'Name of ingestion file columns (present as file headers).',
  data_type:
    'Specifies the type of data (e.g., String, Integer, Date) for the field.',
  length:
    "Specifies the maximum length of the field's data (e.g., 255 for string fields).",
  common_regex:
    "Set the format for date or timestamp fields (e.g., YYYY-MM-DD). If not present, please choose 'Data Type' as 'string'.",
  nullable: 'Select if the field must always contain data.',
  cleanspclchar:
    'Prevents processing of data. Does not encrypt fields. For e.g., SSNs or Credit Card Numbers.',
};

export const redshiftScreen2Tooltips = {
  name: 'Name of ingestion table columns (present as table headers).',
  data_type:
    'Specifies the type of data (e.g., String, Integer, Date) for the field.',
  length:
    "Specifies the maximum length of the field's data (e.g., 255 for string fields).",
  common_regex:
    'Specifies the format for date or timestamp fields (e.g., YYYY-MM-DD).',
  nullable: 'Selected if the field must always contain data.',
  cleanspclchar:
    'Prevents processing of data. Does not encrypt fields. For e.g., SSNs or Credit Card Numbers.',
};

export const s3MappingTooltips = {
  displayText: 'Map your ingestion file fields to these common system fields. ',
  description: 'Describes the data the field should contain.',
  column: 'Choose the matching field from the ingested file.',
  length:
    'Maximum number of characters allowed by the system for this field. Ingested values longer than this will be rejected or truncated',
};

export const redshiftMappingTooltips = {
  displayText: 'Map your ingestion table fields to these common system fields.',
  description: 'Describes the data the field should contain.',
  column: 'Choose the matching field from the ingested table.',
  length:
    'Maximum number of characters allowed by the system for this field. Ingested values longer than this will be rejected or truncated',
};

export const dummyHeadersPreJoin = [
  {
    header: 'Field Name *',
    key: 'name',
  },
  {
    header: 'Is Lookup?',
    key: 'isLookup',
  },
  {
    header: 'Data Type *',
    key: 'data_type',
  },
  {
    header: 'Length',
    key: 'length',
  },
  {
    header: 'Dedupe Key',
    key: 'dedupe_key',
  },
  {
    header: 'Default Value',
    key: 'default',
  },
];

export const matchingTableHeaders = [
  {
    header: 'System Field',
    key: 'displayText',
    align: 'bottom',
  },
  {
    header: 'Max Characters Limit',
    key: 'length',
    align: 'bottom',
  },
  {
    header: 'System Field Description',
    key: 'description',
    align: 'bottom',
  },
  {
    header: 'Source Ingestion Field',
    key: 'column',
    align: 'bottom',
  },
];

export const matchingFieldsMap = dataCategory => {
  const isBusinessData = dataCategory === 'Business Data';
  return [
    {
      displayText: isBusinessData
        ? 'BUSINESS NAME'
        : 'FULL NAME (Check if you have "Full name" field)',
      key: 'DP_A360_FULLNAME',
      id: 'DP_A360_FULLNAME',
      length: 100,
      description: isBusinessData
        ? 'The business name.'
        : "The individual's full name i.e. given name with surname or family name.",
      ...(isBusinessData && { isMandatory: true }),
    },
    ...(isBusinessData
      ? []
      : [
          {
            displayText: 'PREFIX',
            key: 'DP_A360_PREFIX',
            id: 'DP_A360_PREFIX',
            length: 100,
            description: 'Title before the name (e.g., Mr., Ms., Dr.)',
          },
          {
            displayText: 'FIRST NAME',
            key: 'DP_A360_FIRST',
            id: 'DP_A360_FIRST',
            length: 100,
            description: 'The individual’s given name.',
            isMandatory: true,
          },
          {
            displayText: 'LAST NAME',
            key: 'DP_A360_LAST',
            id: 'DP_A360_LAST',
            length: 100,
            description: 'The individual’s surname or family name.',
            isMandatory: true,
          },
          {
            displayText: 'MIDDLE NAME',
            key: 'DP_A360_MIDDLE',
            id: 'DP_A360_MIDDLE',
            length: 100,
            description:
              'Additional given name(s) between the first and last names.',
          },
          {
            displayText: 'SUFFIX',
            key: 'DP_A360_SUFFIX',
            id: 'DP_A360_SUFFIX',
            length: 100,
            description: 'Suffix after the name (e.g., Jr., Sr., III).',
          },
          {
            displayText: 'GENDER',
            key: 'DP_A360_GENDER',
            id: 'DP_A360_GENDER',
            length: 100,
            description: 'The individual’s gender identity.',
          },
          {
            displayText: 'DATE OF BIRTH',
            key: 'DP_A360_DOB',
            id: 'DP_A360_DOB',
            length: 100,
            description: 'The individual’s birth date.',
          },
        ]),

    {
      displayText: 'ADDRESS',
      key: 'DP_A360_ADDRESS',
      id: 'DP_A360_ADDRESS',
      length: 100,
      description: 'Residential address.',
      isEssential: true,
    },
    {
      displayText: 'SECONDARY ADDRESS',
      key: 'DP_A360_SECONDARY',
      id: 'DP_A360_SECONDARY',
      length: 100,
      description: 'Address line 2',
    },
    {
      displayText: 'CITY',
      key: 'DP_A360_CITY',
      id: 'DP_A360_CITY',
      length: 40,
      description: 'The city of the individual’s residence.',
    },
    {
      displayText: 'STATE',
      key: 'DP_A360_PROVINCE',
      id: 'DP_A360_PROVINCE',
      length: 40,
      description: 'The province or state where the individual resides.',
    },
    {
      displayText: 'ZIP CODE',
      key: 'DP_A360_POSTAL',
      id: 'DP_A360_POSTAL',
      length: 10,
      description: 'The zip code for the individual’s address.',
    },
    {
      displayText: 'PLUS4',
      key: 'DP_A360_PLUS4',
      id: 'DP_A360_PLUS4',
      length: 100,
      description: 'Extension to the postal code (e.g., ZIP+4 in the U.S.).',
    },
    {
      displayText: 'ACCOUNT',
      key: 'DP_A360_ACCOUNT',
      id: 'DP_A360_ACCOUNT',
      length: 100,
      isEssential: true,
      description: isBusinessData
        ? 'Account ID of business'
        : 'Customer ID (Leave empty for non-customer feeds)',
    },
    {
      displayText: 'PHONE',
      key: 'DP_A360_PHONE',
      id: 'DP_A360_PHONE',
      length: 20,
      description: 'Primary phone number for the individual.',
      isEssential: true,
    },
    {
      displayText: 'PHONE 1',
      key: 'DP_A360_PHONE_1',
      id: 'DP_A360_PHONE_1',
      length: 20,
      description: 'Alternative or secondary phone number.',
    },
    {
      displayText: 'PHONE 2',
      key: 'DP_A360_PHONE_2',
      id: 'DP_A360_PHONE_2',
      length: 20,
      description: 'Additional phone number, if applicable.',
    },
    {
      displayText: 'EMAIL',
      key: 'DP_A360_EMAIL',
      id: 'DP_A360_EMAIL',
      length: 100,
      description: 'Primary email address.',
      isEssential: true,
    },
    {
      displayText: 'EMAIL 1',
      key: 'DP_A360_EMAIL_1',
      id: 'DP_A360_EMAIL_1',
      length: 100,
      description: 'Secondary email address.',
    },
    {
      displayText: 'EMAIL 2',
      key: 'DP_A360_EMAIL_2',
      id: 'DP_A360_EMAIL_2',
      length: 100,
      description: 'Additional email address.',
    },
    ...(isBusinessData
      ? []
      : [
          {
            displayText: 'COMPANY',
            key: 'DP_A360_COMPANY',
            id: 'DP_A360_COMPANY',
            length: 100,
            description:
              'Name of the company the individual is associated with.',
          },
        ]),
    {
      displayText: 'DIVISION',
      key: 'DP_A360_DIVISION',
      id: 'DP_A360_DIVISION',
      length: 100,
      description: 'Division or department within the company.',
    },
    {
      displayText: 'ADDITIONAL ATTRIBUTE 1',
      key: 'MISC_01',
      id: 'MISC_01',
      length: 100,
      description: 'Additional attribute for supplementary source data.',
    },
    {
      displayText: 'ADDITIONAL ATTRIBUTE 2',
      key: 'MISC_02',
      id: 'MISC_02',
      length: 100,
      description: 'Additional attribute for supplementary source data.',
    },
    {
      displayText: `Suppression Data Fields ${
        dataCategory === 'Suppression Data'
          ? '(Please map atleast 1 field from below system fields)'
          : ''
      } `,
      id: 'supression_header',
      description: '',
      isMandatory: dataCategory === 'Suppression Data' ? true : false,
    },
    {
      displayText: 'DO NOT MAIL',
      key: 'DP_A360_DO_NOT_MAIL',
      id: 'DP_A360_DO_NOT_MAIL',
      length: 1,
      description: 'Do not mail these records',
      isSupression: true,
    },
    {
      displayText: 'DO NOT EMAIL',
      key: 'DP_A360_DO_NOT_EMAIL',
      id: 'DP_A360_DO_NOT_EMAIL',
      length: 1,
      description: 'Do not email these records',
      isSupression: true,
    },
    {
      displayText: 'DO NOT CALL',
      key: 'DP_A360_DO_NOT_CALL',
      id: 'DP_A360_DO_NOT_CALL',
      length: 1,
      description: 'Do not call these records',
      isSupression: true,
    },
    {
      displayText: 'DO NOT CONTACT',
      key: 'DP_A360_DO_NOT_CONTACT',
      id: 'DP_A360_DO_NOT_CONTACT',
      length: 1,
      description: 'Do not contact these records',
      isSupression: true,
    },
    {
      displayText: 'DECEASED',
      key: 'DP_A360_DECEASED',
      id: 'DP_A360_DECEASED',
      length: 1,
      description: 'Deceased records',
      isSupression: true,
    },
  ];
};

export const inputConfigs = {
  encoding: ['ISO-8859-1', 'UTF-8', 'UTF-16', 'UTF-16LE'],
  file_format: ['FIXED', 'DELIMITED'],
  delimiter: ['\\t', ',', '|', ';'],
  qualifier: ['NONE', '\\"', '"'],
  escape: ['\\', '"'],
  new_line: ['\\r\\n', '\\r', '\\n', '\\u000a'],
};

export const escapeOptionsMapping = {
  '\\"': '"',
  '\\\\': '\\',
  "\\\\\\'": "'",
};

export const expectedLayoutFileHeaders = [
  'NAME',
  'NULLABLE',
  'DATA_TYPE',
  'LENGTH',
  'ISLOOKUP',
];
export const initialConfig = {
  name: '',
  data_profile: false,
  data_trim: false,
  IsAllUpperCase: true,
  trim_whitespaces: false,
  allcleanspclchar: false,
  error_threshold: 20,
  join_logic: [],
};

export const initialInputConfig = {
  file_name: '',
  encoding: 'UTF-8',
  file_format: 'FIXED',
  delimiter: '|',
  qualifier: 'NONE',
  escape: '\\"',
  new_line: '\\n',
  hdr: 1,
  trl: 0,
  invalid: false,
  query: '',
  num_of_cols_check: false,
  multiline: false,
  trim_whitespaces: false,
  add_filename_to_reject: false,
  prejoin_generated_fields: [],
  db_config: '',
};

export const initialOutputConfig = {
  encoding: 'UTF-8',
  file_format: 'ATHENA',
  delimiter: ',',
  qualifier: '"',
  escape: '\\',
  new_line: '\\u000a',
  header: false,
};

export const initialValidOutputConfig = {
  file_name: '',
  encoding: 'UTF-8',
  file_format: 'FIXED',
  delimiter: 'NONE',
  qualifier: 'NONE',
  escape: 'NONE',
  new_line: '\\n',
  header: true,
  truncate: true,
  crc_required: false,
  db_config: '',
};

export const initialGenFieldsConfig = {
  name: '',
  data_type: 'varchar',
  length: 1,
  pyspark_logic: '',
  default: '',
  dedupe_key: false,
  // ToDo - Add Lookups
};

export const initialInputFieldsConfig = {
  name: 'FIELD_NAME',
  nullable: false,
  data_type: 'varchar',
  length: 10,
  common_regex: '',
  regex: '',
  dedupe_key: false,
  default: '',
  isLookup: false,
  cleanspclchar: true,
  IsUpper: false,
};
export const initialPreJoinFieldsConfig = {
  name: '',
  data_type: '',
  length: 1,
  dedupe_key: false,
  default: '',
  isLookup: false,
};
export const configsOptions = {
  reject_output_type: ['NONE', 'JSON'],
};

export const pysparkFunctionMap = {
  'when()': 'F.when(condition, value)',
  'when().otherwise': 'F.when(condition, value).otherwise(value)',
  'expr()': 'F.expr(expression)',
  'split()': 'F.split(string, splitString, limit?)',
  'concat()': 'F.concat(*array)',
  'concat_ws()': 'F.concat_ws(separator, *array)',
  'substring()': 'F.substring(string, position, length)',
  'regexp_replace()': 'F.regexp_replace(string, replaceString, replaceWith)',
  'trim()': 'F.trim(string)',
  'row_number()': 'F.row_number()',
  'isNull()': '.isNull()',
  'endswith()': '.endswith(string)',
  'startswith()': '.startswith(string)',
};

export const logicFunctionsMap = {
  'upper()': 'upper(COL_NAME)',
  'substring()': 'substring(COL_NAME, position, length )',
  'lower()': 'lower(COL_NAME)',
  'startswith()': '.startswith(string)',
  'endswith()': '.endswith(string)',
  'split()': 'split(string, splitString, limit?)',
  'concat()': 'concat(*array)',
};

export const logicalOperators = [
  'and',
  'or',
  'any',
  'all',
  'not',
  'some',
  'in',
  'exists',
  'between',
];

export const operators = ['==', '!=', '>', '<', '>=', '<='];

export const dataCategoryMappping = {
  'Customer Data': {
    precedence: 2,
    feedType: 'Type 1',
    contentType: ['Full', 'Incremental'],
  },
  'Business Data': {
    precedence: 2,
    feedType: 'Type 1',
    contentType: ['Full', 'Incremental'],
  },
  'Prospect Data': {
    precedence: 3,
    feedType: 'Type 1',
    contentType: ['Full', 'Incremental'],
  },
  'Suppression Data': {
    precedence: 1,
    feedType: 'Type 1',
    contentType: ['Full', 'Incremental'],
  },
  'Transaction Data': {
    precedence: 2,
    contentType: ['Incremental'],
    feedType: 'Type 2',
  },
  '3rd Party Data Enrichment': {
    precedence: 4,
    feedType: 'Type 2',
    contentType: ['Full', 'Incremental'],
  },
  'Campaign Data': {
    contentType: ['Incremental'],
    feedType: 'Type 3',
  },
  'Lookup Data': {
    feedType: 'Type 3',
    contentType: ['Full', 'Incremental'],
  },
};

export const feedType = {
  'Type 1': 'Data containing PII that require ID resolution or modified PII.',
  'Type 2': 'Data containing PII that can be matched using hard keys.',
  'Type 3':
    'Data that does not contain PII and requires no processing or matching can be processed in near real-time and inserted into the database as-is.',
};

/**
 * Minimum record count the actual ingestion file must contain for Data Profiling
 * categories. Configuration is allowed with fewer records (a non-blocking warning
 * is shown); the minimum is enforced later by the main ingestion DAG. Must stay
 * in sync with the backend MIN_ROWS_SAMPLE_FILE.
 */
export const MIN_RECORDS_FOR_SMALL_FILE = 100;

/**
 * Feed category labels that require Data Profiling. For these categories, when the
 * sample file has fewer than MIN_RECORDS_FOR_SMALL_FILE records, the UI shows a
 * non-blocking warning that the actual ingestion file must contain at least that
 * many records (otherwise it will fail during main-DAG ingestion). Must stay in
 * sync with the backend DATA_PROFILING_CATEGORIES.
 */
export const DATA_PROFILING_CATEGORIES = [
  'Customer Data',
  'Business Data',
  'Prospect Data',
  'Suppression Data',
];

/** Exact warning copy shown during configuration for Data Profiling categories. */
export const SMALL_FILE_WARNING_MESSAGE =
  'Warning: The actual ingestion file must contain at least 100 records. ' +
  'Files with fewer than 100 records will fail during processing.';

export const contentType = {
  Full:
    'File contains all data available at source in each iteration. Example- Customer File.',
  Incremental:
    'File contains new records not shared in any of previous iterations. Example- Interactions File.',
};

export const volumeOfData = {
  Full: [
    'Daily - upto 10,000,000',
    'Weekly - >10,000,000 and <= 40,000,000',
    'Monthly - > 40,000,000',
  ],
  Incremental: [
    'Daily - upto 100,000',
    'Weekly - >100,000 and <= 900,000',
    'Monthly - >900,000',
  ],
};

export const precedence = ['1', '2', '3', '4', '5'];

/** Tooltip copy for profile-gated (visible but disabled) Step 1 options. */
export const PROFILE_DISABLED_DATA_CATEGORY_TOOLTIP =
  'This data category is not enabled. Contact administrator for access.';

export const PROFILE_DISABLED_VOLUME_TOOLTIP =
  'This volume of data option is not enabled. Contact administrator for access.';

export const errorThresholds = [
  '5',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
];

export const dateFormatReadMap = {
  'DATENULL_yyyy-MM-dd': 'yyyy-MM-dd',
  'DATE_yyyy-MM-dd': 'yyyy-MM-dd',
  'DATENULL_MM/dd/yyyy': 'MM/dd/yyyy',
  'DATE_MM/dd/yyyy': 'MM/dd/yyyy',
  'DATENULL_dd/MM/yyyy': 'dd/MM/yyyy',
  'DATE_dd/MM/yyyy': 'dd/MM/yyyy',
  DATENULL_yyyyMMdd: 'yyyyMMdd',
  DATE_yyyyMMdd: 'yyyyMMdd',
  'DATENULL_MMM dd, yyyy': 'MMM dd, yyyy',
  'DATE_MMM dd, yyyy': 'MMM dd, yyyy',
  'DATENULL_dd-MMM-yyyy': 'dd-MMM-yyyy',
  'DATE_dd-MMM-yyyy': 'dd-MMM-yyyy',
  'DATENULL_EEE, MMM d, yyyy': 'EEE, MMM d, yyyy',
  'DATE_EEE, MMM d, yyyy': 'EEE, MMM d, yyyy',
  'DATENULL_yyyy/MM/dd': 'yyyy/MM/dd',
  'DATE_yyyy/MM/dd': 'yyyy/MM/dd',
};

export const timestampFormatReadMap = {
  'DATENULL_yyyy-MM-dd HH:mm:ss': 'yyyy-MM-dd HH:mm:ss',
  'DATE_yyyy-MM-dd HH:mm:ss': 'yyyy-MM-dd HH:mm:ss',
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss": "yyyy-MM-dd'T'HH:mm:ss",
  "DATE_yyyy-MM-dd'T'HH:mm:ss": "yyyy-MM-dd'T'HH:mm:ss",
  'DATENULL_MM/dd/yyyy HH:mm:ss': 'MM/dd/yyyy HH:mm:ss',
  'DATE_MM/dd/yyyy HH:mm:ss': 'MM/dd/yyyy HH:mm:ss',
  'DATENULL_dd/MM/yyyy HH:mm:ss': 'dd/MM/yyyy HH:mm:ss',
  'DATE_dd/MM/yyyy HH:mm:ss': 'dd/MM/yyyy HH:mm:ss',
  'DATENULL_yyyy-MM-dd HH:mm:ss UTC': 'yyyy-MM-dd HH:mm:ss UTC',
  'DATE_yyyy-MM-dd HH:mm:ss UTC': 'yyyy-MM-dd HH:mm:ss UTC',
  'DATENULL_yyyy-MM-dd HH:mm:ss.SSS': 'yyyy-MM-dd HH:mm:ss.SSS',
  'DATE_yyyy-MM-dd HH:mm:ss.SSS': 'yyyy-MM-dd HH:mm:ss.SSS',
  'DATENULL_yyyyMMdd HH:mm:ss': 'yyyyMMdd HH:mm:ss',
  'DATE_yyyyMMdd HH:mm:ss': 'yyyyMMdd HH:mm:ss',
  'DATENULL_EEE, MMM d, yyyy HH:mm:ss': 'EEE, MMM d, yyyy HH:mm:ss',
  'DATE_EEE, MMM d, yyyy HH:mm:ss': 'EEE, MMM d, yyyy HH:mm:ss',
  'DATENULL_yyyy/MM/dd HH:mm:ss': 'yyyy/MM/dd HH:mm:ss',
  'DATE_yyyy/MM/dd HH:mm:ss': 'yyyy/MM/dd HH:mm:ss',
  "DATENULL_yyyy-MM-dd'T'HH:mm:ssXXX": "yyyy-MM-dd'T'HH:mm:ssXXX",
  "DATE_yyyy-MM-dd'T'HH:mm:ssXXX": "yyyy-MM-dd'T'HH:mm:ssXXX",
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSSXXX": "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
  "DATE_yyyy-MM-dd'T'HH:mm:ss.SSSXXX": "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
  'DATENULL_dd-MMM-yyyy HH:mm:ss': 'dd-MMM-yyyy HH:mm:ss',
  'DATE_dd-MMM-yyyy HH:mm:ss': 'dd-MMM-yyyy HH:mm:ss',
  "DATE_yyyy-MM-dd'T'HH:mm:ss CST": "yyyy-MM-dd'T'HH:mm:ss CST",
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSS CST": "yyyy-MM-dd'T'HH:mm:ss.SSS CST",
  "DATE_yyyy-MM-dd'T'HH:mm:ss.SSS CST": "yyyy-MM-dd'T'HH:mm:ss.SSS CST",
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss EST": "yyyy-MM-dd'T'HH:mm:ss EST",
  "DATE_yyyy-MM-dd'T'HH:mm:ss EST": "yyyy-MM-dd'T'HH:mm:ss EST",
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSS EST": "yyyy-MM-dd'T'HH:mm:ss.SSS EST",
  "DATE_yyyy-MM-dd'T'HH:mm:ss.SSS EST": "yyyy-MM-dd'T'HH:mm:ss.SSS EST",
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss PST": "yyyy-MM-dd'T'HH:mm:ss PST",
  "DATE_yyyy-MM-dd'T'HH:mm:ss PST": "yyyy-MM-dd'T'HH:mm:ss PST",
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSS PST": "yyyy-MM-dd'T'HH:mm:ss.SSS PST",
  "DATE_yyyy-MM-dd'T'HH:mm:ss.SSS PST": "yyyy-MM-dd'T'HH:mm:ss.SSS PST",
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss MST": "yyyy-MM-dd'T'HH:mm:ss MST",
  "DATE_yyyy-MM-dd'T'HH:mm:ss MST": "yyyy-MM-dd'T'HH:mm:ss MST",
  "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSS MST": "yyyy-MM-dd'T'HH:mm:ss.SSS MST",
  "DATE_yyyy-MM-dd'T'HH:mm:ss.SSS MST": "yyyy-MM-dd'T'HH:mm:ss.SSS MST",
};

export const dateFormatWriteMap = {
  'yyyy-MM-dd': {
    true: 'DATENULL_yyyy-MM-dd',
    false: 'DATE_yyyy-MM-dd',
  },
  'MM/dd/yyyy': {
    true: 'DATENULL_MM/dd/yyyy',
    false: 'DATE_MM/dd/yyyy',
  },
  'dd/MM/yyyy': {
    true: 'DATENULL_dd/MM/yyyy',
    false: 'DATE_dd/MM/yyyy',
  },
  yyyyMMdd: {
    true: 'DATENULL_yyyyMMdd',
    false: 'DATE_yyyyMMdd',
  },
  'MMM dd, yyyy': {
    true: 'DATENULL_MMM dd, yyyy',
    false: 'DATE_MMM dd, yyyy',
  },
  'dd-MMM-yyyy': {
    true: 'DATENULL_dd-MMM-yyyy',
    false: 'DATE_dd-MMM-yyyy',
  },
  'yyyy/MM/dd': {
    true: 'DATENULL_yyyy/MM/dd',
    false: 'DATE_yyyy/MM/dd',
  },
};

export const timestampFormatWriteMap = {
  'EEE, MMM d, yyyy': {
    true: 'DATENULL_EEE, MMM d, yyyy',
    false: 'DATE_EEE, MMM d, yyyy',
  },
  'yyyy-MM-dd HH:mm:ss': {
    true: 'DATENULL_yyyy-MM-dd HH:mm:ss',
    false: 'DATE_yyyy-MM-dd HH:mm:ss',
  },
  "yyyy-MM-dd'T'HH:mm:ss": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss",
  },
  'yyyy-MM-dd HH:mm:ss UTC': {
    true: 'DATENULL_yyyy-MM-dd HH:mm:ss UTC',
    false: 'DATE_yyyy-MM-dd HH:mm:ss UTC',
  },
  'MM/dd/yyyy HH:mm:ss': {
    true: 'DATENULL_MM/dd/yyyy HH:mm:ss',
    false: 'DATE_MM/dd/yyyy HH:mm:ss',
  },
  'dd/MM/yyyy HH:mm:ss': {
    true: 'DATENULL_dd/MM/yyyy HH:mm:ss',
    false: 'DATE_dd/MM/yyyy HH:mm:ss',
  },
  'yyyy-MM-dd HH:mm:ss.SSS': {
    true: 'DATENULL_yyyy-MM-dd HH:mm:ss.SSS',
    false: 'DATE_yyyy-MM-dd HH:mm:ss.SSS',
  },
  'yyyyMMdd HH:mm:ss': {
    true: 'DATENULL_yyyyMMdd HH:mm:ss',
    false: 'DATE_yyyyMMdd HH:mm:ss',
  },
  'EEE, MMM d, yyyy HH:mm:ss': {
    true: 'DATENULL_EEE, MMM d, yyyy HH:mm:ss',
    false: 'DATE_EEE, MMM d, yyyy HH:mm:ss',
  },
  'yyyy/MM/dd HH:mm:ss': {
    true: 'DATENULL_yyyy/MM/dd HH:mm:ss',
    false: 'DATE_yyyy/MM/dd HH:mm:ss',
  },
  "yyyy-MM-dd'T'HH:mm:ssXXX": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ssXXX",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ssXXX",
  },
  "yyyy-MM-dd'T'HH:mm:ss.SSSXXX": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
  },
  'dd-MMM-yyyy HH:mm:ss': {
    true: 'DATENULL_dd-MMM-yyyy HH:mm:ss',
    false: 'DATE_dd-MMM-yyyy HH:mm:ss',
  },
  "yyyy-MM-dd'T'HH:mm:ss CST": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss CST",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss CST",
  },
  "yyyy-MM-dd'T'HH:mm:ss.SSS CST": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSS CST",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss.SSS CST",
  },
  "yyyy-MM-dd'T'HH:mm:ss EST": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss EST",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss EST",
  },
  "yyyy-MM-dd'T'HH:mm:ss.SSS EST": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSS EST",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss.SSS EST",
  },
  "yyyy-MM-dd'T'HH:mm:ss PST": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss PST",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss PST",
  },
  "yyyy-MM-dd'T'HH:mm:ss.SSS PST": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSS PST",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss.SSS PST",
  },
  "yyyy-MM-dd'T'HH:mm:ss MST": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss MST",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss MST",
  },
  "yyyy-MM-dd'T'HH:mm:ss.SSS MST": {
    true: "DATENULL_yyyy-MM-dd'T'HH:mm:ss.SSS MST",
    false: "DATE_yyyy-MM-dd'T'HH:mm:ss.SSS MST",
  },
};

export const dedupeKeyHeader = [
  {
    header: 'Dedupe Field',
    key: 'text',
  },
];

export const dedupeOrderHeader = [
  {
    header: 'Order No.',
    key: 'priority',
  },
  {
    header: 'Order Field',
    key: 'text',
  },
  {
    header: 'Order By',
    key: 'order',
  },
];

export const feedSchedulingMap = {
  'Business Data': '2 times a day',
  'Customer Data': '2 times per day',
  'Prospect Data': '2 times per day',
  'Suppression Data': '2 times per day',
  'Transaction Data': '4 times per day',
  '3rd Party Data Enrichment': '4 times per day',
  'Campaign Data': '6 times per day',
  'Lookup Data': '6 times per day',
};
